module.exports = __webpack_public_path__ + "img/eu.5418fb2a.png";